<template>
<div class="div_sec">

  <el-row :gutter="60">
    <el-col :span="24" class="card-01">
      <el-row>
        <el-col :span="21" class="modal_title middle_blue">Přehledy
        </el-col>
        <el-col :span="21"> <span class="modal_title green small">{{ patient.pat_surname }} {{ patient.pat_name }}</span>
        </el-col>
        <el-col :span="3" style="margin-bottom: 50px;">

        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-table
            ref="revs_table"
            :data="reviews"
            style="width: 100%; word-break: normal;"
            v-loading="loading_reviews"
            element-loading-text="Loading..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(211, 227, 218, 0.8)"
            :default-sort="{prop:'id_review', order:'ascending'}"
            border
            highlight-current-row
            :stripe="true"
            @sort-change="SortChange_reviews"
            >
            <el-table-column
              prop="id_review"
              label="ID události"
              width="180"
              sortable="custom"
              >
            </el-table-column>
            <el-table-column
              prop="review_type"
              label="Typ události"
              min-width="200"
              sortable="custom"
              >
            </el-table-column>
            <el-table-column
              prop="review_date"
              label="Datum události"
              min-width="200"
              sortable="custom"
              >
            </el-table-column>

            <el-table-column
              width="320"
              fixed="right"
              label="Akce"
              align="right"
              >
              <template slot-scope="props">
                <el-button-group>
                  <el-button class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="review_show( props.$index, props.row, $event )">Detail</el-button>
                </el-button-group>
              </template>
            </el-table-column>

          </el-table>
        </el-col>
      </el-row>
    </el-col>
  </el-row>


</div>

</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  let notifier = new Vue();

  export default {
    computed: {
      ...mapState({

        reviews: state => state.reviews,
        medication: state => state.medication,
        patient: state => state.patient,
        examination: state => state.examination,
        operation: state => state.operation,
        checkup: state => state.checkup,
        sorting_reviews: state => state.sorting_reviews,
        loading_reviews: state => state.loading_reviews,
      }),

      ...mapGetters({


      }),

    },


    data () {
      return {

      }
    },

    methods: {
      ...mapMutations({

        m_modal_operation: 'm_modal_operation',
        m_operation_reset: 'm_operation_reset',
        m_modal_operation_ro: 'm_modal_operation_ro',

        m_examination_reset: 'm_examination_reset',
        m_modal_examination: 'm_modal_examination',
        m_modal_examination_ro: 'm_modal_examination_ro',

        m_checkup_reset: 'm_checkup_reset',
        m_modal_checkup: 'm_modal_checkup',
        m_modal_checkup_ro: 'm_modal_checkup_ro',

        m_medication_reset: 'm_medication_reset',
        m_modal_medication: 'm_modal_medication',
        m_modal_medication_ro: 'm_modal_medication_ro',

      }),


      ...mapActions({

        a_reviews: 'a_reviews',
        a_examination: 'a_examination',
        a_operation: 'a_operation',
        a_checkup: 'a_checkup',
        a_medication: 'a_medication',

      }),


      handleChange(value) {
        console.log(value);
      },


       SortChange_reviews(val) {
        this.sorting_reviews.sorting_prop = val.prop;
        this.sorting_reviews.sorting_ordering = val.order;
        this.a_reviews();
      },


      tableRowClassName({row, rowIndex}) {
        if (row.status === 0) {
          return 'row_0';
        } else if (row.status === 1) {
          return 'row_0';
        } else if (row.status === 2) {
          return 'row_0';
        } else if (row.status === 3) {
          return 'row_0';
        } else if (row.status === 4) {
          return 'row_0';
        } else {
          return 'row_0';
        }
      },


      review_show (index, row, event) {
        if (row.review_type === "Diagnóza/událost") {
          this.m_modal_examination_ro(true);
          this.m_examination_reset();
          this.examination.id_examination = row.id_review;
          this.a_examination({ 'id_examination': row.id_review });
          this.m_modal_examination(true);
        } else if (row.review_type === "Operace") {
          this.m_modal_operation_ro(true);
          this.m_operation_reset();
          this.operation.id_operation = row.id_review;
          this.a_operation({ 'id_operation': row.id_review });
          this.m_modal_operation(true);
        } else if (row.review_type === "Léčba") {
          this.m_modal_medication_ro(true);
          this.m_medication_reset();
          this.medication.id_medication = row.id_review;
          this.a_medication({ 'id_medication': row.id_review });
          this.m_modal_medication(true);
        } else if (row.review_type === "Kontrola") {
          this.m_modal_checkup_ro(true);
          this.m_checkup_reset();
          this.checkup.id_checkup = row.id_review;
          this.a_checkup({ 'id_checkup': row.id_review });
          this.m_modal_checkup(true);
        } else if (row.review_type === "xxx") {

        }
      },


    },

    beforeMount () {
    },

    created () {
    },

    mounted () {

    },

    beforeDestroy () {
    },


  }
</script>

<style lang="scss" scoped>

.el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_3 {
  background: rgb(248, 186, 157) !important;
}

.el-table .row_4 {
  background: rgb(197, 248, 208) !important;
}

.el-table .row_9 {
  background: rgb(250, 197, 184) !important;
}

.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #0ada14 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

.el-select .el-input {
  width: 220px !important;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item {
   margin-bottom: 0 !important;
  }

.el-select {
  padding: 0 20px 10px 0 !important;
}

.el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #7b8d9f;
    cursor: not-allowed;
}

.el-loading-spinner i {
  font-size: 70px !important;
}

.el-loading-spinner {
  top: 25% !important;
}



</style>

